import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import { transformWhitObjectId } from 'modules/common/constants/object-id';
import { CLIENTS_LIST_KEY } from 'modules/crm/clients/constants';
import { ClientsService } from 'modules/crm/clients/services';
import { addressFilters } from 'lib/dfl-address-filter';
import { sanitizeTextFilter } from 'utils/search.utils';
import { TermFilter } from '@dofleini/query-builder';

// address filters
export const provincesFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'city',
  justUseFor: 'CU',
  hideCity: true,
});

export const clientFilter: Filter = {
  filter: 'common:client',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'owner',
  labelKey: 'fullName',
  field: 'owner',
  fetchFunc: ClientsService.search,
  fetchOption: { size: 200 },
  queryKey: CLIENTS_LIST_KEY,
  transform: (value) => transformWhitObjectId(value, 'owner'),
};

export const emailFilter: Filter = {
  filter: 'clients:fields.email',
  translate: true,
  field: 'person.email',
  key: 'email',
  type: FilterType.TEXT,
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'person.email',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};

export const phoneFilter: Filter = {
  filter: 'common:phone',
  translate: true,
  type: FilterType.TEXT,
  key: 'ph',
  field: 'person.phone',
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'person.phone',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};

export const addressBookAdminFilters = [clientFilter, emailFilter, phoneFilter, ...provincesFilter, createdATFilter];
export const addressBookFilters = [clientFilter, emailFilter, phoneFilter];
